const colors: { [name: string]: string } = {
  red: '#FDDCDB',
  blue: '#D8E6FF',
  green: '#DCEDDC',
  purple: '#EBDEF0',
  orange: '#FAE5D3',
  lochinvar: '#E5F5F5',
  prelude: '#EDE8F5',
  goldPurple: '#E9EBF7',
  manhattan: '#FBEFE5',
  pigPink: '#FDE9EF',
  downy: '#B0E4D3',
  grandis: '#FFE7BD',
  matterhorn: '#A59AA4',
  winterHazel: '#EBE9CF',
  regentStBlue: '#D3EAF0',
  turquoise: '#A0F4E9',
  pueblo: '#C7968B',
  limeade: '#BFDB80',
  peachCream: '#FFF7ED',
  gorse: '#FFF2A3',
  bightSun: '#FFE9A4',
  sun: '#FFD887',
  white: '#FFFFFF',
  gray: '#9E9E9E'
}

const cache = {}

class ColorMixer {
  static string2hex(color: string): string {
    return colors[color]
  }

  static mix(color1: string, color2: string, weight = 50) {
    const cacheKey = color1 + color2

    if (cache[cacheKey]) {
      return cache[cacheKey]
    }

    color1 = color1.substr(1)
    color2 = color2.substr(1)

    let color = '#'

    for (let i = 0; i <= 5; i += 2) {
      const v1 = parseInt(color1.substr(i, 2), 16)
      const v2 = parseInt(color2.substr(i, 2), 16)

      let val = Math.floor(v2 + (v1 - v2) * (weight / 100.0)).toString(16)

      while (val.length < 2) {
        val = '0' + val
      }

      color += val
    }

    cache[cacheKey] = color

    return color
  }
}

export default ColorMixer
